import React from 'react';
import { Helmet } from 'react-helmet-async';
import {
  apparelCategoryLargeDefaultImage,
  apparelCategoryMediumDefaultImage,
  apparelCategorySmallDefaultImage,
  foodCategoryLargeDefaultImage,
  foodCategoryMediumDefaultImage,
  foodCategorySmallDefaultImage,
  useDispatch,
  useSelector,
} from '../../../imports/generalImport';
import { Container } from '../../../imports/muiImport';

import { HeroSlider } from '../../../components/HeroSlider';
import MobileHotDeals from '../../mobileComponents/mobileProductCard/MobileHotDeals';
import MobileHomeSearch from '../../mobileComponents/mobileHomeSearch/MobileHomeSearch';
import MobileListVoucher from '../../mobileComponents/mobileProductCard/MobileListVoucher';
import MobileHomeCategory from '../../mobileComponents/mobileHomeCategory/MobileHomeCategory';
import MobileFeatureComponent from '../../mobileComponents/mobileFeatureComponent/MobileFeatureComponent';
import MobileThreeGridComponent from '../../mobileComponents/mobileProductCard/MobileThreeGridComponent';

import { updateHomepageReducer } from '../../../store/homepage/action';
import { fetchMobileHomepage } from '../../../apiCalls/urls/urlFunction';

const foodDefaultImages = {
  largeImage1: foodCategoryLargeDefaultImage,
  mediumImage1: foodCategoryMediumDefaultImage,
  mediumImage2: foodCategoryMediumDefaultImage,
  smallImage1: foodCategorySmallDefaultImage,
  smallImage2: foodCategorySmallDefaultImage,
};

const apparelDefaultImages = {
  largeImage1: apparelCategoryLargeDefaultImage,
  mediumImage1: apparelCategoryMediumDefaultImage,
  mediumImage2: apparelCategoryMediumDefaultImage,
  smallImage1: apparelCategorySmallDefaultImage,
  smallImage2: apparelCategorySmallDefaultImage,
};

function MobileHomePage() {
  const dispatch = useDispatch();
  // const bestSellerData = useSelector((state) => state?.MobileHomepage?.allData?.bestseller);
  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const mobileHomepageResponse = await fetchMobileHomepage();

        if (mobileHomepageResponse?.status) {
          dispatch(updateHomepageReducer(mobileHomepageResponse?.data));
        } else {
          console.error(mobileHomepageResponse?.error);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [dispatch]);

  const foodData = useSelector((state) => state?.MobileHomepage?.allData?.topfive?.[0]);
  const apparelData = useSelector((state) => state?.MobileHomepage?.allData?.topfive?.[1]);
  const hotDealsData = useSelector((state) => state?.MobileHomepage?.allData?.['hotDeals']);
  const mostSellingData = useSelector((state) => state?.MobileHomepage?.allData?.['mostSelling']);

  return (
    <>
      <Helmet>
        <title>Gift Cards: Discounted eGift Cards for 250+ Brands in India</title>
        <meta
          name="description"
          content="99Gift offers a wide variety of discounted gift cards for over 250 brands in India, including Apparels, eCommerce, Entertainment, Travels, Food, Entertainment, Grocery, Mobile, Footwear Etc. You can also find E-Gift cards for personal and commercial use"
        />
        <meta property="og:title" content="99Gift - 200+ Brands Discount Gift Vouchers Online" />
        <meta
          property="og:description"
          content="99Gift offers a wide variety of discounted gift cards for over 250 brands in India, including Apparels, eCommerce, Entertainment, Travels, Food, Entertainment, Grocery, Mobile, Footwear Etc. You can also find E-Gift cards for personal and commercial use"
        />
      </Helmet>

      <Container disableGutters>
        <MobileHomeSearch />
        <HeroSlider height={190} />
        <MobileHomeCategory />
        <MobileFeatureComponent />
        <MobileListVoucher
          title={'Food Gift Vouchers'}
          products={foodData?.['products']}
          redirectLink={'/card-list?category=food'}
          defaultImages={foodDefaultImages}
        />
        <MobileHotDeals title={'Hot Deals'} products={hotDealsData} redirectLink={'/card-list'} />
        <MobileThreeGridComponent
          title={'Most Selling Vouchers'}
          products={mostSellingData}
          redirectLink={'/card-list'}
        />
        <MobileListVoucher
          title={'Apparel Gift Vouchers'}
          products={apparelData?.['products']}
          redirectLink={'/card-list?category=apparel'}
          defaultImages={apparelDefaultImages}
        />{' '}
      </Container>
    </>
  );
}

export default MobileHomePage;
